module.exports = __webpack_public_path__ + "assets/img/00197.54d32d84.png";